export default __webpack_public_path__ + "assets/images/b91ea3cf7a319b5167b4c3fe8b755440.jpg";